import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { getStationDescription } from '../../../lib/utils/generateStationSchema';
import { getStationBrand } from '../../../lib/utils/station';
import StationPropType from '../../prop-types/station';

export default function StationHelmet({
  station,
}) {
  const { t } = useTranslation(['station', 'amenity']);
  const { address, brands, name } = station;
  const stationTitle = [
    name,
    address.line1,
    [address.locality, address.region].join(', '), 'GasBuddy.com',
  ].join(' - ');

  const stationDescription = getStationDescription(station, t);
  const stationBrandId = getStationBrand(brands)?.brandId || 0;

  return (
    <Helmet>
      <title>{stationTitle}</title>
      <meta name="description" content={stationDescription} />
      <meta property="og:title" content={stationTitle} />
      <meta property="og:image" content={`https://images.gasbuddy.com/di/b/1/${stationBrandId}.png?w=256`} />
      <meta property="og:description" content={stationDescription} />
      <meta name="twitter:title" content={stationTitle} />
      <meta name="twitter:image" content={`https://images.gasbuddy.com/di/b/1/${stationBrandId}.png?w=256`} />
      <meta name="twitter:description" content={stationDescription} />
    </Helmet>
  );
}

StationHelmet.propTypes = {
  station: StationPropType,
};

StationHelmet.defaultProps = {
  station: {},
};
